import React from 'react';
import { BtnChiTietKhachHang } from './BtnChiTietKhachHang';
import { BtnChiTietHopDong } from './BtnChiTietHopDong';
import { BtnChiTietNhanVay } from './BtnChiTietNhanVay';

export const ContentTable = ({ list, columns, pageIndex, pageSize, phanQuyen, onOpenModalHopDong, onOpenModalKhachHang, onOpenModalNhanVay }) => {
    
    const renderCellContent = (col, item) => {
        if (col.isCustomerLink) {
            return phanQuyen?.chi_chitietkhachhang
                ? <BtnChiTietKhachHang item={item} onOpenModalKhachHang={onOpenModalKhachHang} />
                : item[col.accessor];
        }
        if (col.isContractLink) {
            if (item.ChoVayID) {
                return phanQuyen?.chi_chitiethopdong
                    ? <BtnChiTietHopDong item={item} onOpenModalHopDong={onOpenModalHopDong} />
                    : item[col.accessor];
            }
            if (item.NhanVayID) {
                return phanQuyen?.chi_chitiethopdong
                    ? <BtnChiTietNhanVay item={item} onOpenModalNhanVay={onOpenModalNhanVay}/>
                    : item[col.accessor];
            }
            return item[col.accessor];
        }
        if (col.render) {
            return col.render(item);
        }
        return item[col.accessor];
    };
    
    return (
        <>
            {list.map((item, index) => (
                <div 
                    key={item.ThuChiId || index} 
                    className={`custom-table-row ${item.LoaiPhieu === 'Phiếu Chi' ? 'phieu-chi' : 'phieu-thu'}`} 
                    style={{ minHeight: "56px", borderBottom: '1px solid #e0e0e0' }}
                >
                    <div className="custom-table-cell flex-basis-5 flex-basis-5-sm">
                        <span className="mobile-column-name color7-bold">STT</span>
                        <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                            {(pageIndex - 1) * pageSize + index + 1}
                        </div>
                    </div>
                    {columns.map(col => {
                        let justifyValue = 'flex-start';
                        if (col.align === 'text-center') justifyValue = 'center';
                        if (col.align === 'text-right') justifyValue = 'flex-end';

                        return (
                            <div key={col.accessor} className={`custom-table-cell ${col.className}`}>
                                <span className="mobile-column-name color7-bold">{col.header}</span>
                                <div 
                                    className={`center-wrapper word-break ${col.align}`} 
                                    style={{ width: '100%', justifyContent: justifyValue }}
                                >
                                   {renderCellContent(col, item)}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))} 
        </>
    );
};